import React from "react";
import {FormControl, FormHelperText, InputLabel, MenuItem, Select, SelectChangeEvent} from "@mui/material";
import {EElementType, elementsNameKey} from "../../../models/utils/EElementType";
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    elementType?: EElementType,
    setElementType: (elementType: EElementType) => void,
}

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 16/05/2022
 * @last_update 16/05/2022
 **/
class SelectElementType extends React.Component<Props> {

    state = {
        isError: false,
    }

    private getElements() {
        const elements = elementsNameKey.map(value => value);
        elements.pop();
        return elements;
    }

    render() {

        /**
* Retrieves from the props the function to access the translation.
**/
const getTranslation = this.props.t;

        /**
         * Return the helper text to display depending on the error status.
         * @returns {string} The correct helper text.
         */
        const getHelperText = (): string => {
            let helperText: string;
            if(this.state.isError) {
                helperText = getTranslation("steps.select.element.input-error");
            } else {
                helperText = getTranslation("steps.select.element.helper");
            }
            return helperText;
        }

        /**
         * Function called when the input is changing.
         * Checks the data filled in. If they are correct, report them to the parent component. Displays the adapted error otherwise.
         * @param {SelectChangeEvent<string>} event
         */
        const onFieldChange = (event: SelectChangeEvent<number | string>) => {
            const elementType = event.target.value;
            if(elementType in EElementType) {
                this.setState({isError: false});
                this.props.setElementType(elementType as EElementType);
            } else {
                this.setState({isError: true});
            }
        }

        return (

            <FormControl fullWidth>
                <InputLabel id="select-element-label">{getTranslation("steps.select.element.label")} *</InputLabel>
                <Select
                    labelId="select-element-label"
                    id="select-element-input"
                    value={this.props.elementType !== undefined ? this.props.elementType : ''}
                    label={getTranslation("steps.select.element.label")}
                    error={this.state.isError}
                    onChange={onFieldChange}
                    required
                    fullWidth
                >
                    {
                        this.getElements().map((element: string, index: number) => (
                            <MenuItem key={index} value={index}>{getTranslation(element)}</MenuItem>
                        ))
                    }
                </Select>
                <FormHelperText>{getHelperText()}</FormHelperText>
            </FormControl>

        );

    };

}

export default withTranslation()(SelectElementType);
